/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */


import { Component, Input, ElementRef, Renderer, ViewEncapsulation, HostBinding } from '@angular/core';
import { Inject, Optional, Host, forwardRef } from '@angular/core';

import classNames from 'classnames';

import { Table } from './table';
/**
 * 表格：注脚
 */
export class TableFooter {
/**
 * 用户CSS样式
 */
class: string;
/**
 * 样式前缀
 * @return {?}
 */
get prefixCls(): string {
        return this.table && this.table.prefixCls || '';
    }
/**
 * @param {?} _renderer
 * @param {?} _elementRef
 * @param {?} table
 */
constructor(
private _renderer: Renderer,
private _elementRef: ElementRef,
private table: Table) {

    }
/**
 * @return {?}
 */
get classes(): string {
        return classNames({
            [`${this.prefixCls}-footer`]: 1
        }, this.class);
    }


static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'table-footer',
    template: `<ng-content></ng-content>`,
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
{type: Table, decorators: [{ type: Inject, args: [forwardRef(() => Table), ] }, { type: Optional }, { type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'class': [{ type: Input },],
'classes': [{ type: HostBinding, args: ['class', ] },],
};
}

function TableFooter_tsickle_Closure_declarations() {
/** @type {?} */
TableFooter.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TableFooter.ctorParameters;
/** @type {?} */
TableFooter.propDecorators;
/**
 * 用户CSS样式
 * @type {?}
 */
TableFooter.prototype.class;
/** @type {?} */
TableFooter.prototype._renderer;
/** @type {?} */
TableFooter.prototype._elementRef;
/** @type {?} */
TableFooter.prototype.table;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
